import React from 'react';
import { Route } from 'react-router-dom';

import { ADMIN_TAXES_APP_PATHS } from '../constants/taxes-app-paths.constants';
import AdminTaxesView from '../views/admin/AdminTaxes.view';

export default function AdminTaxesRoutes() {
  return (
    <React.Fragment>
      <Route exact path={ADMIN_TAXES_APP_PATHS.TAXES_LIST} component={AdminTaxesView} />
    </React.Fragment>
  );
}
